export default __webpack_public_path__ + "static/media/review-3.61090565.jpg";